// constants/medication.ts
import type { Medication, QuantityUnit, DoseUnit, Frequency, Interval, DurationUnit } from '../types/medication';

export const QUANTITY_UNITS: QuantityUnit[] = [
  "BOITE(s)",
  "PLAQUETTE(s)",
  "FLACON(s)",
  "ROULEAU(s)",
  "MORCEAU(s)",
  "AMP"
];

export const DOSE_UNITS: DoseUnit[] = [
  "CP",
  "CUILLERE",
  "GELULE",
  "SACHET",
  "GOUTTE",
  "UI",
  "AMP",
  "DOSE",
  "POIDS",
  "OVULE",
  "BOUFFEE",
  "SOLUTION",
  "SUPPOSITOIRE",
  "APPLICATION",
  "PULVERISATION"
];

export const FREQUENCIES: Frequency[] = [
  "1 Fois",
  "2 Fois",
  "3 Fois",
  "4 Fois",
  "5 Fois",
  "6 Fois"
];

export const INTERVALS: Interval[] = [
  "Par 24H",
  "Par 12H",
  "Par 8H",
  "Par 6H",
  "Par 4H"
];

export const DURATION_UNITS: DurationUnit[] = [
  "Jours",
  "Semaine(s)",
  "Mois"
];

export const DEFAULT_MEDICATION: Omit<Medication, 'id' | 'orderNumber'> = {
  name: "",
  quantity: 1,
  quantityUnit: "BOITE(s)",
  dose: 1,
  doseUnit: "CP",
  frequency: "1 Fois",
  interval: "Par 24H",
  duration: 7,
  durationUnit: "Jours",
  startDate: "",
  endDate: "",
  advice: "",
  priority: "normal",
  instructions: ""
};

// utils/medication.ts
let orderCounter = 1;

export const generateOrderNumber = (): string => {
  const orderNumber = `ORD${orderCounter.toString().padStart(3, '0')}`;
  orderCounter++;
  return orderNumber;
};

export const resetOrderCounter = (): void => {
  orderCounter = 1;
};

export const calculateEndDate = (startDate: string, duration: number, unit: string): string => {
  if (!startDate || !duration) return startDate;
  
  const start = new Date(startDate);
  let daysToAdd = duration;
  
  switch (unit) {
    case "Semaine(s)":
      daysToAdd = duration * 7;
      break;
    case "Mois":
      daysToAdd = duration * 30;
      break;
    default: // "Jours"
      daysToAdd = duration;
  }
  
  const endDate = new Date(start);
  endDate.setDate(start.getDate() + daysToAdd);
  
  return endDate.toISOString().split('T')[0];
};